var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAssociations = function SvgAssociations(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 37,
    viewBox: "0 0 33 37",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1673 -662)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00b195",
    d: "M1691.931 690.065c-3.328 1.657-7.129 2.959-10.071 2.959V695c3.406 0 7.541-1.466 10.959-3.168 1.725-.859 3.306-1.798 4.566-2.682 1.227-.86 2.253-1.739 2.76-2.496l-1.651-1.096c-.287.43-1.046 1.131-2.25 1.976-1.17.82-2.665 1.71-4.313 2.53zm-14.98-20.083c-2.436 7.28-2.461 15.407-.794 20.39l1.882-.625c-1.507-4.505-1.532-12.188.794-19.14zm22.274 9.451l1.775-.884c-.91-1.814-3.071-3.869-5.982-5.849-2.949-2.005-6.789-4.016-11.217-5.7l-.708 1.846c4.302 1.636 8 3.578 10.806 5.486 2.843 1.934 4.65 3.753 5.326 5.101z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00b195",
    d: "M1684 667c0-2.761-2.015-5-4.5-5s-4.5 2.239-4.5 5 2.015 5 4.5 5 4.5-2.239 4.5-5zm-1.875.005c0-1.614-1.175-2.922-2.625-2.922s-2.625 1.308-2.625 2.922 1.175 2.922 2.625 2.922 2.625-1.308 2.625-2.922z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00b195",
    d: "M1682 694c0-2.761-2.015-5-4.5-5s-4.5 2.239-4.5 5 2.015 5 4.5 5 4.5-2.239 4.5-5zm-1.875.005c0-1.614-1.175-2.922-2.625-2.922s-2.625 1.308-2.625 2.922 1.175 2.922 2.625 2.922 2.625-1.308 2.625-2.922z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00b195",
    d: "M1706 683c0-2.761-2.015-5-4.5-5s-4.5 2.239-4.5 5 2.015 5 4.5 5 4.5-2.239 4.5-5zm-1.875.005c0-1.614-1.175-2.922-2.625-2.922s-2.625 1.308-2.625 2.922 1.175 2.922 2.625 2.922 2.625-1.308 2.625-2.922z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAssociations, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/associations.f69ac742.svg";
export { ForwardRef as ReactComponent };